import { FaFacebookSquare, FaInstagramSquare, FaLinkedin } from 'react-icons/fa'
import { GrYoutube } from 'react-icons/gr'
import { IoNewspaperOutline } from 'react-icons/io5'
import { SiOrcid } from 'react-icons/si'

export const refLinkMap = {
  linkedin: {
    Icon: FaLinkedin,
    baseUrl: 'https://linkedin.com/',
  },
  orcid: {
    Icon: SiOrcid,
    baseUrl: 'https://orcid.org/',
  },
  instagram: {
    Icon: FaInstagramSquare,
    baseUrl: 'https://instagram.com/',
  },
  facebook: {
    Icon: FaFacebookSquare,
    baseUrl: 'https://facebook.com/',
  },
  youtube: {
    Icon: GrYoutube,
    baseUrl: 'https://youtube.com/user/',
  },
  other: {
    Icon: IoNewspaperOutline,
    baseUrl: '',
  },
}
